/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A VDK Web utility library. (@accedo/vdkweb-utils) 5.0.2
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOnline = exports.isCommonJs = exports.domExists = void 0;

var domExists = function domExists() {
  return !!(typeof window !== 'undefined' && window.document);
};

exports.domExists = domExists;

var isCommonJs = function isCommonJs() {
  return !!(typeof module !== 'undefined' && module.exports);
};

exports.isCommonJs = isCommonJs;

var isOnline = function isOnline() {
  return domExists() && navigator.onLine;
};

exports.isOnline = isOnline;